import {PropsWithChildren} from 'react';

import * as styles from './left-content.scss';

export function LeftContent(props: PropsWithChildren<unknown>): JSX.Element {
    const {children} = props;

    return <div className={styles.LeftContent}>{children}</div>;
}
